import axios from 'axios';

export const authService = {
    login: (user) => axios.post(`/authn/login`, user, { auth: false }),

    signIn: (user) => axios.post(`/authn/signin`, user, { auth: false }),

    logOut: () => axios.post(`/authn/logout`, {}, { auth: true }),

    getLink: (email) => axios.get(`/authn/forgotPassword/${email}`, { auth: false }),

    confirmAccount: (passwords) =>
        axios.post(
            `/authn`,
            {
                newPassword: passwords?.newPassword,
                confirmation: passwords?.confirmation,
            },
            { headers: { 'registration-token': passwords?.token }, auth: false }
        ),

    resetPass: (passwords) =>
        axios.post(
            `/authn/resetPassword`,
            {
                newPassword: passwords?.newPassword,
                confirmation: passwords?.confirmation,
            },
            { headers: { 'reset-token': passwords?.token }, auth: false }
        ),

    changePasswordService: (data) => axios.post('/authn/changePassword', data, { auth: true }),

    changeNotificationService: (id, data) => axios.patch(`/staff/notifications`, data, { auth: true }),

    updateScheduleViewService: (data) => axios.patch(`/staff/schedule-view`, data, { auth: true }),

    myProfileService: () => axios.get(`/staff/myProfile`, { auth: true }),

    /** Access service */
    getAccessService: (id) => axios.get(`/authn/${id}`, { auth: true }),

    addAccessService: (userId, roleId) => axios.patch(`/authn/${userId}/${roleId}/addRole`, null, { auth: true }),

    removeAccessService: (userId, roleId) => axios.patch(`/authn/${userId}/${roleId}/removeRole`, null, { auth: true }),
    /** End */

    /** Mailer service */
    mailer: (data) => axios.post(`/mailer/contact-form`, data, { auth: false }),
    /** End */

    saveQrScanningService: (body) => axios.post(`/qr/scan`, body, { auth: false }),
};
